import QuadrantControls from '@aytm/app/stats/page/question-views/bpm/components/quadrant/Controls'
import QuadrantChart from '@aytm/app/stats/page/question-views/bpm/components/quadrant/QuadrantChart'
import QuadrantTable from '@aytm/app/stats/page/question-views/bpm/components/quadrant/QuadrantTable'
import { CHART_HEIGHT as QUADRANT_CHART_HEIGHT } from '@aytm/app/stats/page/question-views/bpm/components/quadrant/components/chart/Chart'

import TvControls from '@aytm/app/stats/page/question-views/bpm/components/tv/Controls'
import TvHeader from '@aytm/app/stats/page/question-views/bpm/components/tv/TvHeader'
import TvChart from '@aytm/app/stats/page/question-views/bpm/components/tv/TvChart'
import TvTable from '@aytm/app/stats/page/question-views/bpm/components/tv/TvTable'
import { CHART_HEIGHT as TV_CHART_HEIGHT } from '@aytm/app/stats/page/question-views/bpm/components/tv/components/chart/Chart'

import MdsControls from '@aytm/app/stats/page/question-views/bpm/components/mds/Controls'
import MdsHeader from '@aytm/app/stats/page/question-views/bpm/components/mds/MdsHeader'
import MdsChart from '@aytm/app/stats/page/question-views/bpm/components/mds/MdsChart'
import MdsTable from '@aytm/app/stats/page/question-views/bpm/components/mds/MdsTable'

import { CHART_HEIGHT } from '@aytm/app/stats/page/question-views/components/lib/constants'

// What each sub-mode is drawn by. Every part takes the block's view, so composing a sub-mode is a
// lookup rather than a branch, and a mode's own filters, chart and table stay in its own folder.
//
// `height` is the placeholder height, each sub-mode's own chart height so nothing jumps when the chart
// arrives; `split` asks the strip for the wide layout a sub-mode needs when what it says about itself
// does not fit beside the filters. The quadrant says nothing about itself and so has no header.
export const MODES = {
  q: {
    Controls: QuadrantControls,
    Header: null,
    Chart: QuadrantChart,
    Table: QuadrantTable,
    height: QUADRANT_CHART_HEIGHT
  },
  t: { Controls: TvControls, Header: TvHeader, Chart: TvChart, Table: TvTable, height: TV_CHART_HEIGHT },
  m: { Controls: MdsControls, Header: MdsHeader, Chart: MdsChart, Table: MdsTable, height: CHART_HEIGHT, split: true }
}
